import { createFileRoute, redirect } from "@tanstack/react-router";

// Kept working: doctors' emailed links were minted against this path.
export const Route = createFileRoute("/physician/referrals/$requestId")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/physician/$requestId", params: { requestId: params.requestId } });
  },
});
